module.exports = __webpack_public_path__ + "static/img/code.2a1a2bad.jpg";